import {ThemeColorName, ThemeType} from '../../../theme';

export const mapColorToBase = (
  theme: ThemeType,
  color?: ThemeColorName,
): string | undefined => (color ? theme.colors[color] : undefined);
